/* 
Displays the Transcoder Table retrieval progress bar
*/
import { Stack, Text, Tooltip, Progress, Center } from "@mantine/core";

export default function ProgressBar(props) {
  if (props.isErr) {
    return (
      <Stack spacing={0}>
        <Progress color="red" size="lg" value={100} striped />
        <Tooltip label={"Transactions will still work, but cost a bit more gas. Please refresh the page to try again"}>
          <Center>
            <Text className="textLink" style={{ cursor: "help" }}>
              Error getting Orchestrator list
            </Text>
          </Center>
        </Tooltip>
      </Stack>
    );
  } else if (!props.thisProgress || props.thisProgress == 100) {
    return null;
  }
  return (
    <Stack spacing={0}>
      <Progress
        color="#86c232"
        size="lg"
        value={props.thisProgress}
        striped
        animate
      />
      <Tooltip
        label={
          "We are currently retrieving the list of Orchestrators from the BondingManager smart contract. This way, we can provide the Bonding Manager with hints when increasing or decreasing our stake. These will bring down the cost of a transaction, so it is advised to wait until this bar is filled!"
        }
      >
        <Center>
          <Text className="textLink" style={{ cursor: "help" }}>
            Retrieving Orchestrators...
          </Text>
        </Center>
      </Tooltip>
    </Stack>
  );
}
